export default "__VITE_ASSET__fb8dea4e__"